<div class="form-group mt-4 mt-lg-0">
  <button (click)="loginTM()" class="btn btn-primary btn-block login-button font-size-14 w-100 fw-bold text-white">
    <span>Login with</span> <span><img src="/assets/images/ticketmaster.svg" class="tm-logo ps-2 mb-1" /></span>
  </button>
</div>

<fgbcl-errors></fgbcl-errors>
